export enum GenderEnum {
    "Male" = "Male",
    "Female" = "Female",
    "Other" = "Other"
}